export default {
    maxStringLength(str, max) {
        if (str?.length > max) {
            return str.substr(0, max) + '...';
        }
        return str;
    },
}